var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPaypal = function SvgPaypal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1 3H5.9c-.5 0-.7.3-.8.5L3 15.9c0 .2.1.4.4.4h3.2l.8-4.3v-.2c.1-.3.4-.5.7-.5h2.4c2.2-.2 4.5-1.2 5-4.4v-.1c.6-2.9-1.7-3.8-4.4-3.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m8.3 12.3-.9 5h-1v.2c0 .2.1.4.4.4h2.5c.5 0 .7-.1.8-.5l.5-3c.1-.4.3-.6.7-.6h.4c.8 0 4.5 0 5.1-3.8.2-1.1 0-2-.4-2.5-.4 1.9-1.4 3.1-2.7 3.9-1.3.8-2.9 1-4.2 1l-1.2-.1z"
  })));
};
export default SvgPaypal;